module.exports = __webpack_public_path__ + "static/icons/icon-beach--red-6c1d6d65af4d4a22e1a26000f67f53e3.svg";